import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf061a0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "loginArea",
  class: "login-area"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "login-area-item login"
}

import { defineAsyncComponent, onMounted, onUnmounted, ref, watch } from 'vue'
import { UserInfo } from '@/types'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import avatar from '@/assets/images/header.jpg'


export default /*#__PURE__*/_defineComponent({
  __name: 'loginArea',
  setup(__props) {

const UserCard = defineAsyncComponent(() => import('./userCard.vue'))
const router = useRouter()
const store = useStore()

const userInfo = ref<UserInfo>(store.getters.userInfo)
const userAvatar = ref(userInfo.value.avatar || avatar) // Make this reactive
const isCardVisible = ref(false)

// Watch for changes in the user info from the store
watch(
  () => store.getters.userInfo,
  (newValue) => {
    userInfo.value = newValue
    userAvatar.value = newValue.avatar || avatar // Update the avatar when user info changes
  }
)

const showCard = () => {
  isCardVisible.value = true
}

const hideCard = () => {
  isCardVisible.value = false
}

const handleLoginClick = (type: number) => {
  router.push({
    path: '/login',
    query: { type }
  })
}

const handleClickOutside = (event: MouseEvent) => {
  const loginArea = document.querySelector('.login-area')
  if (loginArea && !loginArea.contains(event.target as Node)) {
    isCardVisible.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (userInfo.value.id)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "login-area-item user",
          onMouseenter: showCard,
          onMouseleave: hideCard
        }, [
          _createElementVNode("img", {
            src: userAvatar.value,
            alt: "头像",
            height: "30",
            width: "30"
          }, null, 8, _hoisted_2),
          _createVNode(_component_el_text, { truncated: "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(userInfo.value.username), 1)
            ]),
            _: 1
          }),
          (isCardVisible.value)
            ? (_openBlock(), _createBlock(_unref(UserCard), {
                key: 0,
                class: "user-card"
              }))
            : _createCommentVNode("", true)
        ], 32))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_button_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                title: "登录",
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleLoginClick(0)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("登录")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                title: "注册",
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleLoginClick(1)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("注册")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
  ], 512))
}
}

})